import './Set/HostedFieldSet';

// https://braintree.github.io/braintree-web/current/DataCollector.html#getDeviceData
